export const RAPIDAPI_KEY = 'YOUR_API_KEY_HERE'
// https://rapidapi.com/chrisgraneyward-Cf0g1vby6xt/api/cbad